module.exports = __webpack_public_path__ + "media/images/svg/logo_GV-d00ad517caa89b80d722d66e2d8fd433.svg";